import '../assets/NcActionText-Ip9hRt85.css';
import { A as ActionTextMixin } from "./actionText-aI0owku1.mjs";
import { openBlock, createElementBlock, createElementVNode, renderSlot, normalizeClass, normalizeStyle, createCommentVNode, toDisplayString, pushScopeId, popScopeId } from "vue";
import { _ as _export_sfc } from "./_plugin-vue_export-helper-1tPrXgE0.mjs";
const _sfc_main = {
  name: "NcActionText",
  mixins: [ActionTextMixin],
  inject: {
    isInSemanticMenu: {
      from: "NcActions:isSemanticMenu",
      default: false
    }
  }
};
const _withScopeId = (n) => (pushScopeId("data-v-824615f4"), n = n(), popScopeId(), n);
const _hoisted_1 = ["role"];
const _hoisted_2 = {
  key: 0,
  class: "action-text__longtext-wrapper"
};
const _hoisted_3 = { class: "action-text__name" };
const _hoisted_4 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("br", null, null, -1));
const _hoisted_5 = ["textContent"];
const _hoisted_6 = ["textContent"];
const _hoisted_7 = {
  key: 2,
  class: "action-text__text"
};
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("li", {
    class: "action",
    role: $options.isInSemanticMenu && "presentation"
  }, [
    createElementVNode("span", {
      class: "action-text",
      onClick: _cache[0] || (_cache[0] = (...args) => _ctx.onClick && _ctx.onClick(...args))
    }, [
      renderSlot(_ctx.$slots, "icon", {}, () => [
        _ctx.icon !== "" ? (openBlock(), createElementBlock("span", {
          key: 0,
          class: normalizeClass([[_ctx.isIconUrl ? "action-text__icon--url" : _ctx.icon], "action-text__icon"]),
          "aria-hidden": "true",
          style: normalizeStyle({ backgroundImage: _ctx.isIconUrl ? `url(${_ctx.icon})` : null })
        }, null, 6)) : createCommentVNode("", true)
      ], true),
      _ctx.name ? (openBlock(), createElementBlock("span", _hoisted_2, [
        createElementVNode("strong", _hoisted_3, toDisplayString(_ctx.name), 1),
        _hoisted_4,
        createElementVNode("span", {
          class: "action-text__longtext",
          textContent: toDisplayString(_ctx.text)
        }, null, 8, _hoisted_5)
      ])) : _ctx.isLongText ? (openBlock(), createElementBlock("span", {
        key: 1,
        class: "action-text__longtext",
        textContent: toDisplayString(_ctx.text)
      }, null, 8, _hoisted_6)) : (openBlock(), createElementBlock("span", _hoisted_7, toDisplayString(_ctx.text), 1)),
      createCommentVNode("", true)
    ])
  ], 8, _hoisted_1);
}
const NcActionText = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-824615f4"]]);
export {
  NcActionText as N
};
